// extracted by mini-css-extract-plugin
module.exports = {"power-backup-R":"R_power-backup-R__2i5d_"};